'use strict';

angular.module('shiftTraderApp')
  .controller('MessagesCtrl', function ($scope, me, notifications, $timeout, Notifications) {
    $scope.me = me;
    $scope.notifications = notifications;
    $scope.showSelector = 'true';

    $timeout(function() {
      Notifications.getReadNotifications()
        .then(function(readNotifications) {
            $scope.notifications = $scope.notifications.concat(readNotifications);
          });
    }, 1000);

    $scope.setNotificationViewed = function(notif) {
      notif.$setViewed()
        .then(function(data) {
          var ind = _.findIndex($scope.notifications, function(n) {
            return n.id === data.id;
          });
          $scope.notifications[ind].viewed = true;

          $timeout(function() {
            $scope.notifications[ind].show = false;
          }, 1000);
        });
    };

    $scope.markAllAsRead = function() {
      _($scope.notifications).where(function(notif) {
        return !notif.viewed;
      }).each(function(notif) {
        $scope.setNotificationViewed(notif);
      });
    };

    $scope.setShow = function(val) {
      $scope.showSelector = val;
    };

  });

